// Single source of truth for detecting/parsing the "@ Shoob" tag that
// reformat-schedules.js appends to a day key when a schedule belongs to
// school 1075 (the in-house Shoob studio "school" record). Was previously
// re-derived ad hoc (`.split('@').length > 1`, `.includes('@ Shoob')`) in
// several places and had drifted out of sync in one of them.
export const SHOOB_DAY_SUFFIX = ' @ Shoob'

export const isShoobDayKey = (dayKey) => !!dayKey && dayKey.includes(SHOOB_DAY_SUFFIX)

export const stripShoobDaySuffix = (dayKey) => dayKey.split('@')[0].trim()

// The studio's own `schools` row (scode 999). A sitting booked AT THE STUDIO
// carries this as its schoolId -- that is the key the server uses to find the
// day's shooting schedule and its capacity, so a booking on a Shoob day MUST
// carry it or the save comes back "No shooting schedule found".
export const STUDIO_SCHOOL_ID = 1075

// Which school a booking belongs to for the day the customer picked. ONE rule,
// used by both the first booking and a later reschedule -- the reschedule path
// was written without it and silently kept the student's high school, which is
// exactly the failure above (Harleen Dhaliwal, Bear Creek -> Aug 30 studio day,
// 2026-08-28).
export const appointmentSchoolId = ({ isAtShoob, schoolId }) => (
  isAtShoob ? STUDIO_SCHOOL_ID : schoolId
)
